import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '../SelectField/SelectField';
import { CronTask } from '../../models';

const CronTaskMethodField = ({ name, optional }) => {
    const { t } = useTranslation();

    const options = CronTask.methods().map(method => ({
        key: method,
        value: method,
        text: method
    }));

    return (
        <SelectField
            name={ name }
            options={ options }
            required={ !optional }
            fluid
            placeholder={t('cron_tasks.method_placeholder')}
            clearable
            selectOnNavigation
        />
    )
}

export default CronTaskMethodField;
